export default {
    brands_main_id: 'Id',
    brands_main_name: 'Nombre',
    brands_main_email: 'Correo',
    brands_main_username: 'Nombre de usuario',
    brands_main_companies: 'Compañias',
    brands_main_brands: 'Marcas',
    brands_main_master_company_name: 'Compañía Maestra',
    brands_main_apply: 'Aplicar',
    brands_main_tags: 'Etiquetas',
    brands_main_active_brands_only: 'Sólo cuentas activas',
    brands_main_yes: 'Si',
    brands_main_no: 'No',
    brands_main_authenticate_cloud: 'Iniciar sesión como cliente',
    brands_main_re_sync_backend_information: 'Re-sincronización de la información del backend',
    brands_main_devices: 'Dispositivos',
    brands_main_package: 'Paquete',
    brands_main_crm: 'Id. de Salesforce',
    brands_main_add_dealer: 'Agregar distribuidor',
    brands_main_edit: 'Editar',
    brands_main_remove_filters: 'Eliminar los filtros',
    brands_main_account_details: 'Detalles de la cuenta',
    brands_main_import_from_p4: 'Importar desde P4',
    brands_main_reprocess_odo_hours: 'Reprocesar Odo/Hrs',
    brands_main_new_status: 'Nuevo Estado',
    brands_main_at: 'el',
    brands_main_next_scheduled_action: 'Próxima acción programada',
    brands_main_on: 'en',
    brands_main_brand: 'Marca',
    brand_overview_tab_messages_templates: 'Plantillas de mensajes',
    brands_main_domains: 'Dominios',
    brands_main_code: 'Código',
    brands_main_home_page: 'Página de inicio',
    brands_main_tos_url: 'URL de términos de servicio',
    brands_main_help_url: 'URL de ayuda',
    brands_main_address: 'Dirección',
    brands_main_phone: 'Teléfono',
    brands_main_login_background_image: 'Imagen de fondo de inicio de sesión',
    brands_main_login_background_color: 'Color de fondo de inicio de sesión',
    brands_main_login_company_logo: 'Logo de la empresa de inicio de sesión',
    brands_main_favicon: 'Favicon',
    brands_main_navigate_to_test_page: 'Navegar a la página de prueba',
    brands_main_add_brand: 'Agregar marca',
    brands_main_delete_brand: 'Eliminar marca',
    brands_main_in_app_logo: 'Logo en la aplicación',
    
};